// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 648) return "static/chunks/648.d486b63d36d2285a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 730 ? "44530001" : chunkId) + "-" + {"370":"92b84e8859eacc17","730":"e1a216550aaf2856"}[chunkId] + ".js";
};